import {Query} from 'react-relay/lib/fromGraphQL';
import RelayQueryRequest from 'react-relay/lib/RelayQueryRequest';

function mapChildren(subQuery, subData) {
    let subResult = {};

    if (subQuery.getSchemaName() === 'edges') {
        let nodeSubQuery = subQuery.getChildren().find(item => item.getSchemaName() === 'node');
        subResult = subData.map(item => {
            return mapChildren(nodeSubQuery, item.node);
        });
    }
    else if (subQuery.getChildren().length > 0) {
        subQuery.getChildren().forEach((children) => {
            subResult[children.getSchemaName()] = mapChildren(children, subData[children.getSerializationKey()]);
        });
    }
    else if (typeof subData === 'object') {
        subResult[subQuery.getSchemaName()] = subData[subQuery.getSerializationKey()];
    }
    else {
        subResult = subData;
    }

    return subResult;
}

function mapResponse(query, data) {
    let storageKey = query.getStorageKey();

    let subResult = {};
    let subData = data[storageKey];
    query.getChildren().forEach((children) => {
        subResult[children.getSchemaName()] = mapChildren(children, subData[children.getSerializationKey()]);
    });

    let result = {};
    result[storageKey] = subResult;

    return result;
}

function replaceVariable(call, variables) {
    if (call.value.kind === "CallVariable") {
        call.value.kind = 'CallValue';
        call.value.callValue = variables[call.value.callVariableName];
        delete call.value.callVariableName;
    }

    return call;
}

function variableReplace(subQuery, variables) {
    if (subQuery.children) {
        subQuery.children = subQuery.children.map(child => variableReplace(child, variables));
    }

    if (subQuery.calls) {
        subQuery.calls = subQuery.calls.map(call => replaceVariable(call, variables));
    }

    return subQuery;
}

// For generic request to server via customizable network layer (e.g. if wanna call request to public api vs to private api)
export default async function request(relayQuery, params, networkLayer) {
    let queryWithVariables = variableReplace(relayQuery, params || {});

    let query = Query(
        queryWithVariables
    );

    let queryRequest = new RelayQueryRequest(
        query
    );

    queryRequest.resolve = (data) => {
        return data.response;
    };

    queryRequest.reject = (err) => {
        return err;
    };

    return networkLayer.sendQueries([
        queryRequest
    ]).then((responses) => {
        return mapResponse(query, responses[0]);
    });
}
